import { createSlice } from '@reduxjs/toolkit';
import { cancelOrder, cancelZelleOrder, fetchAllOdersList, fetchBuyAgainOdersList } from '../thunk/ordersThunk';

const initialState = {
    allOrders: [],
    buyAgainOrders: [],
    allOrdersLoading: true,
    allOrdersError: null,
    buyAgainOrdersLoading: false,
    buyAgainOrdersError: null,
    cancelOrderLoading: false,
    cancelOrderError: null,
};
const orderSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        resetAllOrders: (state) => {
            state.allOrders = [];
            state.allOrdersLoading = false;
            state.allOrdersError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllOdersList.pending, (state) => {
                state.allOrdersLoading = true;
                state.allOrdersError = null;
            })
            .addCase(fetchAllOdersList.fulfilled, (state, action) => {
                state.allOrdersLoading = false;
                state.allOrders = action.payload?.data?.orders || [];
            })
            .addCase(fetchAllOdersList.rejected, (state, action) => {
                state.allOrdersLoading = false;
                state.allOrdersError = action.payload;
            })
            //
            .addCase(fetchBuyAgainOdersList.pending, (state) => {
                state.buyAgainOrdersLoading = true;
                state.buyAgainOrdersError = null;
            })
            .addCase(fetchBuyAgainOdersList.fulfilled, (state, action) => {
                state.buyAgainOrdersLoading = false;
                state.buyAgainOrders = action.payload.data || [];
            })
            .addCase(fetchBuyAgainOdersList.rejected, (state, action) => {
                state.buyAgainOrdersLoading = false;
                state.buyAgainOrdersError = action.payload;
            })
            // Cancel Order
            .addCase(cancelOrder.pending, (state) => {
                state.cancelOrderLoading = true;
                state.cancelOrderError = null;
            })
            .addCase(cancelOrder.fulfilled, (state, action) => {
                state.cancelOrderLoading = false;
                // Update the order status in allOrders if it exists and is an array
                if (Array.isArray(state.allOrders)) {
                    const orderIndex = state.allOrders.findIndex(
                        (order) => order.id === action.meta.arg.order_id,
                    );
                    if (orderIndex !== -1) {
                        state.allOrders[orderIndex].order_status = 98; // Cancelled status
                    }
                }
            })
            .addCase(cancelOrder.rejected, (state, action) => {
                state.cancelOrderLoading = false;
                state.cancelOrderError = action.payload;
            })
            // Cancel Zelle Order
            .addCase(cancelZelleOrder.pending, (state) => {
                state.cancelOrderLoading = true;
                state.cancelOrderError = null;
            })
            .addCase(cancelZelleOrder.fulfilled, (state, action) => {
                state.cancelOrderLoading = false;
                // Update the order status in allOrders if it exists and is an array
                if (Array.isArray(state.allOrders)) {
                    const orderIndex = state.allOrders.findIndex(
                        (order) => order.payment_id === action.meta.arg.payment_id,
                    );
                    if (orderIndex !== -1) {
                        state.allOrders[orderIndex].order_status = 98; // Cancelled status
                    }
                }
            })
            .addCase(cancelZelleOrder.rejected, (state, action) => {
                state.cancelOrderLoading = false;
                state.cancelOrderError = action.payload;
            });
    },
});

export const { resetAllOrders } = orderSlice.actions;
export default orderSlice.reducer;
